import { FeatureIconType } from 'core/components/icons/types'
import React, { useEffect, useRef } from 'react'
import BeachChair from 'core/components/icons/svg/feature/beach-chair.svg?react'
import NewBeachChair from 'core/components/icons/svg/new-feature/beach-chair.svg?react'
import CarInMotion from 'core/components/icons/svg/feature/car-in-motion.svg?react'
import NewCarInMotion from 'core/components/icons/svg/new-feature/car-in-motion.svg?react'
import Everlance from 'core/components/icons/svg/feature/everlance.svg?react'
import EverlanceLogo from 'core/components/icons/svg/feature/everlance-logo.svg?react'
import EverlanceByMotusLogo from 'core/components/icons/svg/feature/everlance-by-motus-logo.svg?react'
import NewEverlanceByMotusLogo from 'core/components/icons/svg/new-feature/everlance-by-motus-logo.svg?react'
import Expenses from 'core/components/icons/svg/feature/expenses.svg?react'
import NewExpenses from 'core/components/icons/svg/new-feature/expenses.svg?react'
import Tags from 'core/components/icons/svg/feature/tags.svg?react'
import NewTags from 'core/components/icons/svg/new-feature/tags.svg?react'
import WorkHours from 'core/components/icons/svg/feature/work-hours.svg?react'
import NewWorkHours from 'core/components/icons/svg/new-feature/work-hours.svg?react'
import DataExports from 'core/components/icons/svg/feature/data-exports.svg?react'
import NewDataExports from 'core/components/icons/svg/new-feature/data-exports.svg?react'
import WalletSendPayments from 'core/components/icons/svg/feature/wallet-send-payments.svg?react'
import NewWalletSendPayments from 'core/components/icons/svg/new-feature/wallet-send-payments.svg?react'
import MoneyInWallet from 'core/components/icons/svg/feature/money-in-wallet.svg?react'
import NewMoneyInWallet from 'core/components/icons/svg/new-feature/money-in-wallet.svg?react'
import PayReport from 'core/components/icons/svg/feature/pay-report.svg?react'
import NewPayReport from 'core/components/icons/svg/new-feature/pay-report.svg?react'
import Rules from 'core/components/icons/svg/feature/rules.svg?react'
import NewRules from 'core/components/icons/svg/new-feature/rules.svg?react'
import Flags from 'core/components/icons/svg/feature/flags.svg?react'
import NewFlags from 'core/components/icons/svg/new-feature/flags.svg?react'
import Wallet from 'core/components/icons/svg/feature/wallet.svg?react'
import NewWallet from 'core/components/icons/svg/new-feature/wallet.svg?react'
import Calendar from 'core/components/icons/svg/feature/calendar.svg?react'
import NewCalendar from 'core/components/icons/svg/new-feature/calendar.svg?react'
import FlagsBanner from 'core/components/icons/svg/feature/flags-banner.svg?react'
import NewFlagsBanner from 'core/components/icons/svg/new-feature/flags-banner.svg?react'
import Insurance from 'core/components/icons/svg/feature/insurance.svg?react'
import NewInsurance from 'core/components/icons/svg/new-feature/insurance.svg?react'
import Categories from 'core/components/icons/svg/feature/categories.svg?react'
import NewCategories from 'core/components/icons/svg/new-feature/categories.svg?react'
import DriverCheckup from 'core/components/icons/svg/feature/driver-checkup.svg?react'
import NewDriverCheckup from 'core/components/icons/svg/new-feature/driver-checkup.svg?react'
import SedanDriving from 'core/components/icons/svg/feature/sedan-driving.svg?react'
import NewSedanDriving from 'core/components/icons/svg/new-feature/car-in-motion.svg?react'
import Product from 'core/components/icons/svg/feature/product.svg?react'
import NewProduct from 'core/components/icons/svg/new-feature/product.svg?react'
import Time from 'core/components/icons/svg/feature/time.svg?react'
import NewTime from 'core/components/icons/svg/new-feature/time.svg?react'
import Trips from 'core/components/icons/svg/feature/trips.svg?react'
import NewTrips from 'core/components/icons/svg/new-feature/trips.svg?react'
import Transactions from 'core/components/icons/svg/feature/transactions.svg?react'
import NewTransactions from 'core/components/icons/svg/new-feature/transactions.svg?react'
import Share from 'core/components/icons/svg/feature/share.svg?react'
import NewShare from 'core/components/icons/svg/new-feature/share.svg?react'
import Reports from 'core/components/icons/svg/feature/reports.svg?react'
import NewReports from 'core/components/icons/svg/new-feature/reports.svg?react'
import Premium from 'core/components/icons/svg/feature/premium.svg?react'
import NewPremium from 'core/components/icons/svg/new-feature/premium.svg?react'
import Location from 'core/components/icons/svg/feature/location.svg?react'
import NewLocation from 'core/components/icons/svg/new-feature/location.svg?react'
import DataExport from 'core/components/icons/svg/feature/data-export.svg?react'
import NewDataExport from 'core/components/icons/svg/new-feature/data-exports.svg?react'
import CreditCards from 'core/components/icons/svg/feature/credit-cards.svg?react'
import NewCreditCards from 'core/components/icons/svg/new-feature/credit-cards.svg?react'
import ExpenseSync from 'core/components/icons/svg/feature/expense-sync.svg?react'
import NewExpenseSync from 'core/components/icons/svg/new-feature/expense-sync.svg?react'
import Confetti from 'core/components/icons/svg/feature/confetti.svg?react'
import NewConfetti from 'core/components/icons/svg/new-feature/confetti.svg?react'
import Clapping from 'core/components/icons/svg/feature/clapping.svg?react'
import NewClapping from 'core/components/icons/svg/new-feature/clapping.svg?react'
import Visibility from 'core/components/icons/svg/feature/visibility.svg?react'
import NewVisibility from 'core/components/icons/svg/new-feature/visibility.svg?react'
import MotusLogo from 'core/components/icons/svg/feature/motus-logo.svg?react'

import cn from 'utils/cn'
import { useSettings } from 'core/hooks/settings/useSettings'

const Icons: Record<
  FeatureIconType,
  React.ComponentType<React.SVGProps<SVGSVGElement>>
> = {
  'beach-chair': BeachChair,
  'car-in-motion': CarInMotion,
  everlance: Everlance,
  'everlance-logo': EverlanceLogo,
  'everlance-by-motus-logo': EverlanceByMotusLogo,
  expenses: Expenses,
  'money-in-wallet': MoneyInWallet,
  'pay-report': PayReport,
  tags: Tags,
  'work-hours': WorkHours,
  'data-exports': DataExports,
  'wallet-send-payments': WalletSendPayments,
  rules: Rules,
  flags: Flags,
  wallet: Wallet,
  calendar: Calendar,
  'flags-banner': FlagsBanner,
  insurance: Insurance,
  categories: Categories,
  'driver-checkup': DriverCheckup,
  'sedan-driving': SedanDriving,
  product: Product,
  time: Time,
  trips: Trips,
  transactions: Transactions,
  share: Share,
  reports: Reports,
  premium: Premium,
  location: Location,
  'data-export': DataExport,
  'credit-cards': CreditCards,
  'expense-sync': ExpenseSync,
  confetti: Confetti,
  clapping: Clapping,
  visibility: Visibility,
  'motus-logo': MotusLogo
}

const NewIcons: Record<
  FeatureIconType,
  React.ComponentType<React.SVGProps<SVGSVGElement>>
> = {
  'beach-chair': NewBeachChair,
  'car-in-motion': NewCarInMotion,
  everlance: Everlance,
  'everlance-logo': EverlanceLogo,
  'everlance-by-motus-logo': NewEverlanceByMotusLogo,
  expenses: NewExpenses,
  'money-in-wallet': NewMoneyInWallet,
  'pay-report': NewPayReport,
  tags: NewTags,
  'work-hours': NewWorkHours,
  'data-exports': NewDataExports,
  'wallet-send-payments': NewWalletSendPayments,
  rules: NewRules,
  flags: NewFlags,
  wallet: NewWallet,
  calendar: NewCalendar,
  'flags-banner': NewFlagsBanner,
  insurance: NewInsurance,
  categories: NewCategories,
  'driver-checkup': NewDriverCheckup,
  'sedan-driving': NewSedanDriving,
  product: NewProduct,
  time: NewTime,
  trips: NewTrips,
  transactions: NewTransactions,
  share: NewShare,
  reports: NewReports,
  premium: NewPremium,
  location: NewLocation,
  'data-export': NewDataExport,
  'credit-cards': NewCreditCards,
  'expense-sync': NewExpenseSync,
  confetti: NewConfetti,
  clapping: NewClapping,
  visibility: NewVisibility,
  'motus-logo': MotusLogo
}

interface FeatureIconProps {
  /**
   * Name of the feature icon to render.
   */
  name: `${FeatureIconType}`
  /**
   * Width of the icon (overrides default SVG width).
   */
  width?: string | number
  /**
   * Height of the icon (overrides default SVG height).
   */
  height?: string | number
  /**
   * Additional class names for the icon container.
   */
  className?: string
}

/**
 * FeatureIcon component for rendering SVG icons by feature name.
 * Supports custom sizing and styling via props.
 */
const FeatureIcon = ({ name, className, height, width }: FeatureIconProps) => {
  const {
    data: {
      featureFlags: { ENABLE_GREEN_APP }
    }
  } = useSettings()
  const svgRef = useRef<SVGSVGElement>(null)
  const Element = ENABLE_GREEN_APP ? NewIcons[name] : Icons[name]

  useEffect(() => {
    if (svgRef.current) {
      const defaultWidth = svgRef.current.getAttribute('width') ?? ''
      const defaultHeight = svgRef.current.getAttribute('height') ?? ''
      if (defaultHeight && defaultWidth) {
        let newWidth: number = (width as number) ?? Number(defaultWidth)
        let newHeight: number = (height as number) ?? Number(defaultHeight)
        if (height && !width) {
          newWidth =
            (Number(height) * Number(defaultWidth)) / Number(defaultHeight)
        } else if (width && !height) {
          newHeight =
            (Number(width) * Number(defaultHeight)) / Number(defaultWidth)
        }
        svgRef.current.setAttribute('width', newWidth.toString())
        svgRef.current.setAttribute('height', newHeight.toString())
        return
      }
      svgRef.current.setAttribute('width', (width as string) ?? defaultWidth)
      svgRef.current.setAttribute('height', (height as string) ?? defaultHeight)
    }
  }, [height, width])

  return (
    <span className={cn(['flex items-center justify-center', className])}>
      <Element ref={svgRef} />
    </span>
  )
}

export default FeatureIcon
